import useDialog from 'components/ConfirmDialog/useDialog';
import usePrevious from 'hooks/usePrevious';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getItem, KEYS } from 'storage';
import { setGlobal } from 'store/global/reducer';
import { CLEAR_UP_REDUX, FETCH_USER, FETCH_USER_MENU, LOAD_ALL_CONFIG, LOGOUT_USER } from 'store/key';
import { LOGOUT_FROM_ANOTHER_TAB } from 'utility/frontendMessage';
import { getIsRefreshingToken, getNotificationCountOfUnread } from 'utility/general';
import api from 'api/call';
import useSubscribe from 'hooks/useSubscribe';

const routes = [
    '/applications/initial-application-form',
    '/applications/create-application-amendment',
    '/post-approval-document/application-amendment-detail',
];

const EventListener = () => {
    const location = useLocation();
    const previousPathname = usePrevious(location.pathname);
    const dispatch = useDispatch();
    const history = useHistory();
    const currentPath = location.pathname;
    const previousPath = usePrevious(currentPath);
    const isLogin = useSelector((state) => state.user.isLogin);
    const prevLogin = usePrevious(isLogin);
    const updateNotificationId = useRef(null);
    const [isLocalStorageLogin, setLocalStorageLogin] = useState(getItem(KEYS.USER_IS_LOGIN));
    const previousLocalStorageLogin = usePrevious(isLocalStorageLogin);
    const showDialog = useDialog();
    const [shouldAppUpdate, setShouldAppUpdate] = useState(false);
    const isShow = useSelector((state) => state.dialog.confirmDialog.isShow);
    const isErrorDialogShow = useSelector((state) => state.global.isErrorShow);
    const backendVersion = useSelector((state) => state.global.backendVersion);

    const isDialogShow = isShow || isErrorDialogShow;

    useSubscribe('changePath', (args) => {
        history.push(args.route);
    });

    // update login status when isLogin key in localStorage changes
    useEffect(() => {
        window.addEventListener(
            'storage',
            () => {
                setLocalStorageLogin(getItem(KEYS.USER_IS_LOGIN));

                // do your checks to detect
                // changes in "e1", "e2" & "e3" here
            },
            false,
        );
    }, []);

    //check if the appShouldUpdate
    useEffect(() => {
        // if popup is showing, wait the popup to dismiss before refreshing the application.
        if (!isDialogShow && shouldAppUpdate) {
            window.location.reload();
        }
    }, [shouldAppUpdate, isDialogShow]);

    useEffect(() => {
        if (previousPathname !== location.pathname) {
            dispatch(
                setGlobal({
                    pathname: location.pathname,
                    previousPathname,
                }),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, previousPathname]);

    useEffect(() => {
        // logout from another tab
        if (!isLocalStorageLogin && previousLocalStorageLogin) {
            if (isLogin) {
                dispatch({
                    type: LOGOUT_USER,
                    payload: {
                        callback: async () => {
                            await showDialog({
                                description: LOGOUT_FROM_ANOTHER_TAB,
                                disableCancelButton: true,
                            });

                            window.location.reload();
                        },
                    },
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLocalStorageLogin, previousLocalStorageLogin]);

    // logout callback
    useEffect(() => {
        if (prevLogin && !isLogin) {
            dispatch({
                type: CLEAR_UP_REDUX,
            });

            history.push('/');

            api.version.getBackendVersion().then((res) => {
                if (backendVersion !== res.data) {
                    setTimeout(() => {
                        setShouldAppUpdate(true);
                    }, 1000);
                }
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLogin, prevLogin]);

    // update user detail when login variable changes to login
    useEffect(() => {
        if (!prevLogin && isLogin) {
            dispatch({
                type: FETCH_USER,
            });

            dispatch({
                type: FETCH_USER_MENU,
                payload: {
                    // role: user.role,
                },
            });

            dispatch({ type: LOAD_ALL_CONFIG });

            getNotificationCountOfUnread();

            if (!updateNotificationId.current) {
                updateNotificationId.current = setInterval(() => {
                    if (getIsRefreshingToken()) {
                        console.log('151346 EventListener.js skipped');
                        return;
                    }

                    if (process.env.NODE_ENV === 'development') {
                        console.log(
                            '141504 NotificationButton.jsx polling for notification is disabled in development environment',
                        );
                    } else {
                        getNotificationCountOfUnread();
                    }
                }, 1000 * 60 * 5);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLogin, prevLogin]);

    // when user is logout, remove the notification polling
    useEffect(() => {
        if (!isLogin) {
            if (updateNotificationId.current) {
                clearInterval(updateNotificationId.current);
                updateNotificationId.current = null;
            }
        }
    }, [isLogin]);

    // fetch user menu when role change when the status is logged in
    useEffect(() => {
        if (isLogin) {
            dispatch({
                type: FETCH_USER_MENU,
                payload: {
                    // role: user.role,
                },
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLogin]);

    // hidden drawer when enter the initial application form
    useEffect(() => {
        routes.forEach((path) => {
            if (currentPath.includes(path) && !previousPath?.includes(path)) {
                dispatch(
                    setGlobal({
                        isShowDrawer: false,
                    }),
                );
            } else if (!currentPath.includes(path) && previousPath?.includes(path)) {
                dispatch(
                    setGlobal({
                        isShowDrawer: true,
                    }),
                );
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPath, previousPath]);

    return null;
};

export default EventListener;
